import React from 'react';

const Spinner = ({ loading, text }) => {
    return (
        <div className={`overlay${loading ? '' : ' hidden'}`}>
            <div className="overlay__inner">
                <div className="overlay__content flex items-center flex-col gap-y-14">
                    <span className="spinner"></span>
                    <div className='text-white text-2xl font-black'>{text}</div>
                </div>

            </div>
        </div>
    )
}

export default Spinner;